import React from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";
import GlobalNavigation from "../Navigation/GlobalNavigation";
import AdminNavigation from "..//Navigation/AdminNavigation";
import CourseNavigation from "../Navigation/CourseNavigation";


function Header ({currentUser, isLoginPopupOpen, onSignInPopupClick, onSignOutPopupClick}) {
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const isCourseRoute = pathParts[1] === "course";
  const courseSlug = isCourseRoute ? pathParts[2] : null; 
  const isLoggedIn = !!currentUser?._id; 
  const isAdmin = currentUser?.role === 9999 || currentUser?.role === "admin" || currentUser?.subscriptionLevel === 9999; 
  //need to deside one way subscriptionLevel or role ! 
  // const isAdmin = currentUser?.role === "admin"; 

  let NavigationComponent = null;
  if (!isLoggedIn) { // Guest
    NavigationComponent = (<GlobalNavigation onDesktopClick={onSignInPopupClick} isLoginOpen={isLoginPopupOpen}/>);
  } else if (isAdmin) { // Admin
    NavigationComponent = (<AdminNavigation currentUser={currentUser} onSignOut={onSignOutPopupClick}/>);
  } else { // Logged user inside course
    NavigationComponent = (<CourseNavigation currentUser={currentUser} onSignOut={onSignOutPopupClick}/>);
  }

  let themeClass = "theme-global"; 
  if (isCourseRoute) {
    if (courseSlug === "html") themeClass = "theme-html";
    if (courseSlug === "fundamentals") themeClass = "theme-fundamentals";
  } 


  return (
    <header className={`header ${themeClass}`}>
      <div className="header-row1"></div>
      {NavigationComponent}
    </header>
  );
  
}

export default Header;